import { accountsConstants } from "../actions/reconciliation/accounts";
import { movementsConstants } from "../actions/reconciliation/movements";
import { operationsConstants } from "../actions/reconciliation/operations";

const defaultState = {
  movements: {
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    },
    list: []
  },
  accounts: {
    status: {
      started: false,
      error: false,
      ended: false,
      errorInfo: {
        code: "",
        message: ""
      }
    },
    list: []
  },
  operations: {
    isCreatingLink: false,
    reconcilableDeadlines: []
  },
  isGettingReconcilableDeadlines: false,
  listData: [],
  isGettingReconciliatonData: false,
  reconciledSummary: null,
  isGettingReconciledSummary: false,
  isReconciledSummaryError: false
};

export default function reconciliation(state, { type, payload }) {
  let defaultS = typeof state === "undefined" ? defaultState : state;
  switch (type) {
  case movementsConstants.GET_RECONCILIATION_MOVEMENTS_START:
    return {
      ...defaultS,
      movements: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case movementsConstants.GET_RECONCILIATION_MOVEMENTS_SUCCESS:
    return {
      ...defaultS,
      movements: {
        status: {
          started: false,
          error: false,
          ended: true
        },
        list: payload.transactions || []
      }
    };
  case movementsConstants.GET_RECONCILIATION_MOVEMENTS_ERROR:
    return {
      ...defaultS,
      movements: {
        status: {
          started: false,
          error: true,
          ended: true
        },
        list: []
      }
    };
  case movementsConstants.SET_MOVEMENT_LINKED:
    // TEMPORANEO DA MODIFICARE
    let newMovements = [];
    defaultS.movements.list.map((item) => {
      if (item.id === payload) {
        item.linked = true;
      }
      return newMovements.push(item);
    });
    return {
      ...defaultS,
      movements: {
        status: {
          started: false,
          error: false,
          ended: true
        },
        list: newMovements
      }
    };
  case accountsConstants.GET_RECONCILIATION_ACCOUNTS_START:
    return {
      ...defaultS,
      accounts: {
        list: [],
        status: {
          started: true,
          error: false,
          ended: false
        }
      }
    };
  case accountsConstants.GET_RECONCILIATION_ACCOUNTS_SUCCESS:
    return {
      ...defaultS,
      accounts: {
        status: {
          started: false,
          error: false,
          ended: true
        },
        list: payload.bankAccounts || []
      }
    };
  case accountsConstants.GET_RECONCILIATION_ACCOUNTS_ERROR:
    return {
      ...defaultS,
      accounts: {
        status: {
          started: false,
          error: true,
          ended: true
        },
        list: []
      }
    };
  case operationsConstants.CREATE_RECONCILIATION_LINK_START:
  case operationsConstants.REMOVE_RECONCILIATION_LINK_START:
    return {
      ...defaultS,
      operations: {
        ...defaultS.operations,
        isCreatingLink: true
      }
    };
  case operationsConstants.CREATE_RECONCILIATION_LINK_SUCCESS:
  case operationsConstants.CREATE_RECONCILIATION_LINK_ERROR:
  case operationsConstants.REMOVE_RECONCILIATION_LINK_SUCCESS:
  case operationsConstants.REMOVE_RECONCILIATION_LINK_ERROR:
    return {
      ...defaultS,
      operations: {
        ...defaultS.operations,
        isCreatingLink: false
      }
    };
  case operationsConstants.GET_RECONCILABLE_DEADLINES_START:
    return {
      ...defaultS,
      isGettingReconcilableDeadlines: true
    };
  case operationsConstants.GET_RECONCILABLE_DEADLINES_ERROR:
    return {
      ...defaultS,
      isGettingReconcilableDeadlines: false
    };
  case operationsConstants.GET_RECONCILABLE_DEADLINES_SUCCESS:
    return {
      ...defaultS,
      operations: {
        ...defaultS.operations,
        isCreatingLink: false,
        reconcilableDeadlines: payload
      },
      isGettingReconcilableDeadlines: false
    };
  case movementsConstants.GET_RECONCILIATION_DATA_START:
    return {
      ...defaultS,
      isGettingReconciliatonData: true
    };
  case movementsConstants.GET_RECONCILIATION_DATA_ERROR:
    return {
      ...defaultS,
      isGettingReconciliatonData: false
    };
  case movementsConstants.GET_RECONCILIATION_DATA_SUCCESS:
    return {
      ...defaultS,
      listData: payload,
      isGettingReconciliatonData: false
    };
  case operationsConstants.GET_RECONCILED_SUMMARY_START:
    return {
      ...defaultS,
      reconciledSummary: null,
      isGettingReconciledSummary: true,
      isReconciledSummaryError: false
    };
  case operationsConstants.GET_RECONCILED_SUMMARY_SUCCESS:
    return {
      ...defaultS,
      reconciledSummary: payload,
      isGettingReconciledSummary: false,
      isReconciledSummaryError: false
    };
  case operationsConstants.GET_RECONCILED_SUMMARY_ERROR:
    return {
      ...defaultS,
      reconciledSummary: null,
      isGettingReconciledSummary: false,
      isReconciledSummaryError: true
    };
  default:
    return defaultS;
  }
}
